import { WelcomeAnimHero } from 'sections/welcomeAnim/welcomAnimHero/WelcomeAnimHero';
import { WhatIsItFor } from 'sections/welcomeAnim/whatIsItFor/WhatIsItFor';
import { CostumeVariations } from 'sections/welcomeAnim/costumeVariations/CostumeVariations';
import { CalculateEvent } from 'sections/shared/calculateEvent/CalculateEvent';

export const WelcomeAnim = () => {
    return (
        <>
            <WelcomeAnimHero />
            <WhatIsItFor />
            <CostumeVariations />
            <CalculateEvent />
        </>
    );
};
